export default __webpack_public_path__ + "static/media/ISR.51ecc828.svg";